// Errors inside setTimeout/setInterval in scripts crash native app but in web simply log the error in console.
// Hence we wrap the callback in try/catch before handing it to the underlying timer.

type TimerKind = 'setTimeout' | 'setInterval';

const wrapTimer =
  <TKind extends TimerKind>(kind: TKind) =>
  (
    callback: (...args: unknown[]) => void,
    delay?: number,
    ...args: unknown[]
  ): ReturnType<TKind extends 'setTimeout' ? typeof setTimeout : typeof setInterval> => {
    const timer = kind === 'setTimeout' ? setTimeout : setInterval;
    return timer(() => {
      try {
        callback(...args);
      } catch (err) {
        console.error(`Error in ${kind} callback inside executeScript:`, err);
      }
    }, delay) as ReturnType<TKind extends 'setTimeout' ? typeof setTimeout : typeof setInterval>;
  };

export const safeSetTimeout = wrapTimer('setTimeout');
export const safeSetInterval = wrapTimer('setInterval');
